import { Alert, AlertTitle, Typography } from '@cmg/design-system';
import React from 'react';

import { AttestationFormStatus } from '../../../../../../graphql';
import { AttestationFormStatusDisplayName } from '../../../../../order-book/attestation/Attestation.model';
import { useComplianceContext } from '../../context/ComplianceContext';
import {
  CertificateTypeLabels,
  getAttestationStatus,
} from '../../context/hooks/certificates/Certificates.model';

const ComplianceActionRequired: React.FC = () => {
  const { warning, attestation, certificateType } = useComplianceContext().certificates;
  const status = getAttestationStatus(attestation) ?? AttestationFormStatus.NotOnFile;

  if (!warning.hasComplianceWarning) {
    return null;
  }

  return (
    <Alert severity="error" data-testid="compliance-action-required-banner">
      <AlertTitle>Action required for this investor</AlertTitle>
      <Typography variant="highlight2" color="primary.light">
        {`${
          certificateType
            ? CertificateTypeLabels[certificateType]
            : CertificateTypeLabels.FORM51305131
        } ${AttestationFormStatusDisplayName[status]}`}
      </Typography>
    </Alert>
  );
};

export default ComplianceActionRequired;
